import toast from "react-hot-toast";

export const doOrder =
  (billingDetails) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const paymentMethod = getState().paymentMethods.selectedMethod;

      let order = {
        noValidation: false,
        cartId: getState().Cart.cart.id,
        autoSplit: true,
        billingDetails: billingDetails,
        paymentMethod: paymentMethod.paymentMethod,
      };

      switch (paymentMethod.paymentMethod) {
        case "ACH_BULK":
          order.paymentDetails = { id: paymentMethod.paymentDetails.id };
          break;
        case "MAILCHECK_BULK":
          order.shippingDetails = {
            ...paymentMethod.shippingDetails,
            street2: paymentMethod.shippingDetails.street2 || "",
          };
          break;
        case "PAYPAL_ACCOUNT_BULK":
          order.paymentDetails = { id: paymentMethod.paypalAccountId };
          break;
        default:
          alert("Unknown payment method.");
          break;
      }

      const orderResponse = await remote(
        "post",
        `v3/orders`,
        order,
        "place order",
        dispatch
      );

      if (orderResponse?.message) {
        throw new Error(orderResponse.message[0]);
      }

      const {
        orders: {
          ecode: { id: eid = null },
          physical: { id: pid = null },
        },
      } = orderResponse;

      history.push(`/order-complete?ecodeUUID=${eid}&physicalUUID=${pid}`);
    } catch (error) {
      toast.error(error.message);
    }
  };
